import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import noDataSvg from 'assets/images/no-data.svg'

const StyledNoDataWrapper = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 64px 0;

  img {
    width: 200px;
    margin-bottom: 24px;
  }

  p {
    color: #596480;
    font-size: 18px;
    margin-bottom: 4px;
    font-weight: 500;
  }

  span {
    color: #7a8499;
    font-size: 14px;
  }
`

const NoData = ({ tips }) => {
  const { t } = useTranslation()

  return (
    <StyledNoDataWrapper>
      <img src={noDataSvg} />
      <p>{t('noResult')}</p>
      <span>{tips ? tips : t('tips.tryAnotherKeywords')}</span>
    </StyledNoDataWrapper>
  )
}

export default NoData
